import {Injectable} from '@angular/core';
import {startWith} from 'rxjs/operators';
import {CustomerPortfolio} from 'src/app/domain/model/customer-portfolio.model';
import CustomerPortfolioApi from 'src/app/domain/service/api/customer-portfolio.api';
import {UserSession} from 'src/app/infrastructure/environment/user-session';
import {Router} from 'src/app/infrastructure/router/router';

export const PORTFOLIO_ID_QUERY_PARAM = 'portfolioId';

@Injectable({
  providedIn: 'root',
})
export class PortfolioQueryParamSelectorService {
  constructor(
    private readonly router: Router,
    private readonly userSession: UserSession,
    private readonly customerPortfolioApi: CustomerPortfolioApi,
  ) {
  }

  public start(): void {
    this.router.changed()
      .pipe(startWith(this.router.currentUrl()))
      .subscribe(() => this.selectPortfolioFromQueryParam().catch(() => undefined));
  }

  private async selectPortfolioFromQueryParam(): Promise<void> {
    const portfolioId = this.router.get(PORTFOLIO_ID_QUERY_PARAM);

    if (!portfolioId || !this.userSession.isLogged() || this.isAlreadySelected(portfolioId)) {
      return;
    }

    const portfolio = await this.findPortfolio(portfolioId);

    if (portfolio) {
      this.customerPortfolioApi.selectPortfolio(portfolio);
    }
  }

  private isAlreadySelected(portfolioId: string): boolean {
    return this.customerPortfolioApi.syncSelected()?.id === portfolioId;
  }

  private async findPortfolio(portfolioId: string): Promise<CustomerPortfolio | undefined> {
    const loadedPortfolio = this.findLoadedPortfolio(portfolioId);

    if (loadedPortfolio) {
      return loadedPortfolio;
    }

    await this.customerPortfolioApi.fetchAll();

    return this.findLoadedPortfolio(portfolioId);
  }

  private findLoadedPortfolio(portfolioId: string): CustomerPortfolio | undefined {
    return (this.customerPortfolioApi.syncAll() ?? []).find(portfolio => portfolio.id === portfolioId);
  }
}
